export default function Numpy_Home() {
  return <div>Numpy_Home Component iu kjdf iue iuasd fhbusaegfu</div>;
}
